var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('page-header',{attrs:{"ecnu":_vm.$organization==='ecnu'}}),_c('div',{staticClass:"privacy"},[_c('div',{staticClass:"page-container",domProps:{"innerHTML":_vm._s(_vm.statement)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }